"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefererUrl = void 0;
/* eslint-disable  @typescript-eslint/camelcase */
/* istanbul ignore file */
var module_util_1 = require("../../utils/module.util");
var index_1 = require("./bff/index");
var getRefererUrl = function (defaultUrl) {
    if (window && window.location)
        return window.location.href;
    return defaultUrl || "unknown";
};
exports.getRefererUrl = getRefererUrl;
var newRelic = (0, module_util_1.getModules)({
    logError: {
        bffFn: index_1.logError_bff
    }
});
exports.default = newRelic;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/newRelic/index.js
// module id = 1338
// module chunks = 11